var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fly-in"}},[(_vm.isVisible)?_c('div',{staticClass:"flash-message",class:_vm.type},[(_vm.isSuccess)?[_c('font-awesome-icon',{staticClass:"flash-message__icon",attrs:{"icon":"check-circle"}})]:_vm._e(),(_vm.message)?_c('p',{staticClass:"flash-message__message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }